import * as yup from 'yup'

export interface FormValues {
  email: string
  name: string
  phone_number: string
  comment: string
  street: string
  city: string
  state: string
  zip_code: string
  title: string
  community_name: string
  community_size: string
}

export const schema: FormValues = {
  email: '',
  name: '',
  phone_number: '',
  comment: '',
  street: '',
  city: '',
  state: '',
  zip_code: '',
  title: '',
  community_name: '',
  community_size: ''
}

export const validation = yup
  .object()
  .shape({
    email: yup
      .string()
      .email('Enter a valid email address')
      .required('Enter an email address'),

    name: yup
      .string()
      .required('This field is required'),

    phone_number: yup
      .string()
      .required('Enter your phone number'),

    comment: yup
      .string(),

    street: yup
      .string(),

    city: yup
      .string(),

    state: yup
      .string(),

    zip_code: yup
      .string(),

    title: yup
      .string(),

    community_name: yup
      .string(),

    community_size: yup
      .string()
  })
